import { render, staticRenderFns } from "./ContributionToCompChannel.vue?vue&type=template&id=31c7e196&scoped=true"
import script from "./ContributionToCompChannel.vue?vue&type=script&lang=js"
export * from "./ContributionToCompChannel.vue?vue&type=script&lang=js"
import style0 from "./ContributionToCompChannel.vue?vue&type=style&index=0&id=31c7e196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7e196",
  null
  
)

export default component.exports